import { useState } from 'react'
import { onChange } from '../../../../../../../../../utils/types'
import { DataType } from '../types/types'


const useCreatEdit = () => {
  const [data, setData] = useState<DataType>({})

  const onChange: onChange = ({ target }) => {
    const { name, value } = target
    setData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handledata = (data?: Record<string, unknown>) => {
    
    if (data) {
      setData((prevData) => ({
        ...prevData,  // Mantenemos los valores actuales de data
        ...data,   // Sobrescribimos solo los valores que se pasan
      }))
    }else{
      setData({})
    }
  }


  return { data, onChange, setData, handledata }
}

export { useCreatEdit }
